import { Search01Icon } from "vega-icons";

import {
  InputControl,
  type InputControlProps,
} from "@vega-core/components/Form/Controls/Input/InputControl";
import { m } from "@vega-core/paraglide/messages";
import { isTruthy } from "@vega-core/utils/isTruthy";

export type SearchInputProps = Omit<InputControlProps, "icon" | "type"> & {
  compact?: boolean;
};

export function SearchInput({
  name,
  value,
  onChange,
  placeholder,
  withBorder = false,
  className,
  disabled = false,
  compact = false,
  background,
  autoFocus = false,
  ...rest
}: SearchInputProps) {
  return (
    <InputControl
      autoFocus={autoFocus}
      background={background}
      className={className}
      data-testid={`search-input-${name}`}
      disabled={disabled}
      icon={<Search01Icon className="h-4 fill-text/secondary" />}
      inputClassName={compact ? "py-0.5" : undefined}
      name={name}
      onChange={onChange}
      placeholder={
        isTruthy(placeholder) ? placeholder : m.placeholders_search()
      }
      type="search"
      value={value}
      withBorder={withBorder}
      {...rest}
    />
  );
}
